/* SP Namen besticken – Designer (sections/sp-namen.liquid). Stand 11.10.2026
   Namen (Eingabe oder Datei .xlsx/.docx/.csv/.txt), 20 Stickschriften, Garnfarbe, Position/Breite, Textilien,
   Live-Vorschau als Stick auf Stoff, Summe und Warenkorb (je Name eine Einheit, Namensliste als Datei-Property). */
(function () {
  'use strict';

  var FONTS = [
    ['Great Vibes', 'script'], ['Dancing Script', 'script'], ['Pacifico', 'script'], ['Satisfy', 'script'], ['Kaushan Script', 'script'], ['Allura', 'script'],
    ['Playfair Display', 'serif'], ['Cinzel', 'serif'], ['Lora', 'serif'], ['Merriweather', 'serif'],
    ['Montserrat', 'sans'], ['Oswald', 'sans'], ['Bebas Neue', 'sans'], ['Poppins', 'sans'], ['Comfortaa', 'sans'], ['Raleway', 'sans'],
    ['Graduate', 'sport'], ['Alfa Slab One', 'sport'], ['Anton', 'sport'], ['Bungee', 'sport']
  ];
  var THREADS = [
    ['weiss', '#F7F7F5', 'Weiß', 'White'], ['schwarz', '#151515', 'Schwarz', 'Black'], ['marine', '#1F2A44', 'Marine', 'Navy'],
    ['royal', '#2457A6', 'Royalblau', 'Royal blue'], ['hellblau', '#7FB2E5', 'Hellblau', 'Light blue'], ['rot', '#C8102E', 'Rot', 'Red'],
    ['bordeaux', '#6B1E2E', 'Bordeaux', 'Burgundy'], ['gruen', '#1F6B3B', 'Grün', 'Green'], ['gelb', '#F2C230', 'Gelb', 'Yellow'],
    ['orange', '#E5762A', 'Orange', 'Orange'], ['grau', '#8D9093', 'Grau', 'Grey'], ['gold', '#C6A15B', 'Gold', 'Gold']
  ];
  var FABRICS = [
    ['#1E2638', 'Navy', 'Navy'], ['#1A1A1A', 'Schwarz', 'Black'], ['#FFFFFF', 'Weiß', 'White'], ['#B9BDBF', 'Grau meliert', 'Heather grey'], ['#A3222E', 'Rot', 'Red']
  ];
  // Positionen und Flächen wie im Shop (Aris-Positionen), Breite in cm als Vorschlag
  var POS = [
    ['bl', 'front', 'Brust links', 'Left chest', 12, 8], ['br', 'front', 'Brust rechts', 'Right chest', 12, 8],
    ['ar', 'front', 'Ärmel rechts', 'Right sleeve', 10, 6], ['na', 'back', 'Nacken', 'Neck', 10, 6],
    ['ru', 'back', 'Schulterblatt', 'Shoulder blade', 30, 20]
  ];
  var MAXLEN = 30;

  var T = {
    de: {
      cats: { all: 'Alle', script: 'Schreibschrift', serif: 'Klassisch', sans: 'Modern', sport: 'Sport' },
      sample: 'Anna Müller', names1: ' Name', namesN: ' Namen',
      tooLong: function (n) { return n + (n === 1 ? ' Name ist' : ' Namen sind') + ' länger als ' + MAXLEN + ' Zeichen – bitte kürzen.'; },
      read: function (n, f) { return n + (n === 1 ? ' Name' : ' Namen') + ' aus „' + f + '“ übernommen – bitte kurz prüfen. Die Datei geht mit der Bestellung an uns.'; },
      readNone: 'In der Datei haben wir keine Namen gefunden. Bitte prüfe die Datei oder füge die Namen direkt ein.',
      badType: 'Bitte als .xlsx, .docx, .csv oder .txt speichern – ältere .xls/.doc lesen wir nicht ein.',
      tooBig: 'Die Datei ist größer als 10 MB.',
      readErr: 'Die Datei konnte nicht gelesen werden. Füge die Namen einfach direkt ein.',
      upTitle: 'Liste hochladen', upFile: function (f) { return f + ' ✓'; },
      max: function (m) { return 'max. ' + m + ' cm, Höhe ergibt sich aus der Schrift'; },
      widthErr: function (m) { return 'Bitte eine Breite bis ' + m + ' cm eintragen.'; },
      texShop: ['Textilien aus unserem Shop', 'Such dir die Textilien im Shop aus. Im Hinweis schreibst du, auf welche Artikel die Namen kommen.'],
      texOwn: ['Eigene Textilien', 'Vorbeibringen, schicken oder vom Händler liefern lassen.'],
      rows: { names: 'Namen', font: 'Schrift', thread: 'Garnfarbe', pos: 'Position', tex: 'Textilien', each: ' je Name' },
      needNames: 'Bitte gib mindestens einen Namen ein.', needTex: 'Bitte wähle bei Schritt 5, woher die Textilien kommen.',
      adding: 'Wird in den Warenkorb gelegt …', added: 'Im Warenkorb.', toCart: 'Zum Warenkorb', toShop: 'Textilien aussuchen',
      fail: 'Das hat nicht geklappt. Bitte versuch es noch einmal oder schreib uns an hallo@shirtplus.net.',
      soldOut: 'Der Namensstick ist gerade nicht bestellbar. Schreib uns gern an hallo@shirtplus.net.',
      more: function (n) { return ' … und ' + n + ' weitere (siehe Namensliste)'; },
      listHead: 'Namensliste Shirtplus – Namensstick', texShopShort: 'aus dem Shop', texOwnShort: 'eigene Textilien'
    },
    en: {
      cats: { all: 'All', script: 'Script', serif: 'Classic', sans: 'Modern', sport: 'Sport' },
      sample: 'Anna Miller', names1: ' name', namesN: ' names',
      tooLong: function (n) { return n + (n === 1 ? ' name is' : ' names are') + ' longer than ' + MAXLEN + ' characters – please shorten.'; },
      read: function (n, f) { return n + (n === 1 ? ' name' : ' names') + ' taken from “' + f + '” – please check them. The file comes to us with your order.'; },
      readNone: 'We found no names in the file. Please check it or paste the names directly.',
      badType: 'Please save as .xlsx, .docx, .csv or .txt – older .xls/.doc files can’t be read.',
      tooBig: 'The file is larger than 10 MB.',
      readErr: 'The file couldn’t be read. Just paste the names directly.',
      upTitle: 'Upload a list', upFile: function (f) { return f + ' ✓'; },
      max: function (m) { return 'max. ' + m + ' cm, the height follows from the font'; },
      widthErr: function (m) { return 'Please enter a width of up to ' + m + ' cm.'; },
      texShop: ['Textiles from our shop', 'Pick the textiles in our shop. In the note, tell us which items the names go on.'],
      texOwn: ['Your own textiles', 'Drop them off, send them or have your supplier deliver them.'],
      rows: { names: 'Names', font: 'Font', thread: 'Thread', pos: 'Position', tex: 'Textiles', each: ' per name' },
      needNames: 'Please enter at least one name.', needTex: 'Please choose at step 5 where the textiles come from.',
      adding: 'Adding to cart …', added: 'In your cart.', toCart: 'Go to cart', toShop: 'Choose textiles',
      fail: 'That didn’t work. Please try again or email us at hallo@shirtplus.net.',
      soldOut: 'Name embroidery can’t be ordered right now. Please email us at hallo@shirtplus.net.',
      more: function (n) { return ' … and ' + n + ' more (see name list)'; },
      listHead: 'Name list Shirtplus – name embroidery', texShopShort: 'from the shop', texOwnShort: 'own textiles'
    }
  };

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fam(n) { return '"SPN ' + n + '", "Trade Gothic Shirtplus", sans-serif'; }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* ---------- Dateien lesen ---------- */
  function loadScript(src) {
    return new Promise(function (ok, no) {
      if (window.JSZip) return ok();
      var s = document.createElement('script'); s.src = src; s.onload = function () { ok(); }; s.onerror = no; document.head.appendChild(s);
    });
  }
  function xmlText(s) {
    return String(s).replace(/<[^>]+>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&#(\d+);/g, function (a, n) { return String.fromCharCode(+n); }).replace(/&amp;/g, '&');
  }
  var HEAD = /^(name|namen|vorname|nachname|first ?name|last ?name|surname|full ?name|spieler|mitarbeiter)$/i;
  // Zeilen (Arrays von Zellen) -> Namen. Mit Kopfzeile: Namensspalten (Vor-/Nachname werden verbunden), sonst erste Spalte.
  function rowsToNames(rows) {
    rows = rows.filter(function (r) { return r.some(function (c) { return String(c || '').trim(); }); });
    if (!rows.length) return [];
    var head = rows[0].map(function (c) { return String(c || '').trim(); });
    var cols = [];
    head.forEach(function (h, i) { if (HEAD.test(h)) cols.push(i); });
    if (cols.length) {
      return rows.slice(1).map(function (r) { return cols.map(function (i) { return String(r[i] || '').trim(); }).filter(Boolean).join(' '); });
    }
    return rows.map(function (r) { var c = r.filter(function (x) { return String(x || '').trim(); }); return String(c[0] || '').trim(); });
  }
  function parseCsv(txt) {
    var lines = txt.replace(/\r/g, '').split('\n');
    var sep = (txt.match(/;/g) || []).length >= (txt.match(/,/g) || []).length ? ';' : ',';
    if (txt.indexOf('\t') >= 0) sep = '\t';
    return rowsToNames(lines.map(function (l) { return l.split(sep).map(function (c) { return c.replace(/^"|"$/g, '').trim(); }); }));
  }
  function readXlsx(zip) {
    var ss = zip.file('xl/sharedStrings.xml');
    var sheets = zip.file(/^xl\/worksheets\/sheet\d+\.xml$/).sort(function (a, b) { return a.name.localeCompare(b.name, undefined, { numeric: true }); });
    if (!sheets.length) return Promise.resolve([]);
    return Promise.all([ss ? ss.async('string') : Promise.resolve(''), sheets[0].async('string')]).then(function (r) {
      var shared = (r[0].match(/<si>[\s\S]*?<\/si>/g) || []).map(function (si) { return xmlText((si.match(/<t[^>]*>[\s\S]*?<\/t>/g) || []).join('')); });
      var rows = (r[1].match(/<row[^>]*>[\s\S]*?<\/row>/g) || []).map(function (row) {
        var cells = [];
        (row.match(/<c [^>]*?(?:\/>|>[\s\S]*?<\/c>)/g) || []).forEach(function (c) {
          var ref = (/ r="([A-Z]+)\d+"/.exec(c) || [])[1] || '';
          var col = 0; for (var i = 0; i < ref.length; i++) col = col * 26 + (ref.charCodeAt(i) - 64);
          col = Math.max(0, col - 1);
          var t = (/ t="([^"]+)"/.exec(c) || [])[1], val = '';
          if (t === 's') val = shared[+((/<v>([\s\S]*?)<\/v>/.exec(c) || [])[1])] || '';
          else if (t === 'inlineStr') val = xmlText((c.match(/<t[^>]*>[\s\S]*?<\/t>/g) || []).join(''));
          else val = xmlText((/<v>([\s\S]*?)<\/v>/.exec(c) || [])[1] || '');
          cells[col] = val;
        });
        return cells;
      });
      return rowsToNames(rows);
    });
  }
  function readDocx(zip) {
    var f = zip.file('word/document.xml');
    if (!f) return Promise.resolve([]);
    return f.async('string').then(function (x) {
      var body = x.replace(/<w:tbl>[\s\S]*?<\/w:tbl>/g, function (tbl) {
        var rows = (tbl.match(/<w:tr[ >][\s\S]*?<\/w:tr>/g) || []).map(function (tr) {
          return (tr.match(/<w:tc>[\s\S]*?<\/w:tc>/g) || []).map(function (tc) { return xmlText((tc.match(/<w:t[ >][\s\S]*?<\/w:t>|<w:t>[\s\S]*?<\/w:t>/g) || []).join('')); });
        });
        return '<w:p>' + rowsToNames(rows).map(function (n) { return '<w:t>' + n.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</w:t>'; }).join('</w:p><w:p>') + '</w:p>';
      });
      return (body.match(/<w:p[ >][\s\S]*?<\/w:p>|<w:p>[\s\S]*?<\/w:p>/g) || []).map(function (p) {
        return xmlText((p.match(/<w:t[ >][\s\S]*?<\/w:t>|<w:t>[\s\S]*?<\/w:t>/g) || []).join(''));
      });
    });
  }
  function readFile(file, jszipUrl) {
    var n = file.name.toLowerCase();
    if (/\.(txt)$/.test(n) || file.type === 'text/plain') return file.text().then(function (t) { return t.replace(/\r/g, '').split('\n'); });
    if (/\.csv$/.test(n) || file.type === 'text/csv') return file.text().then(parseCsv);
    if (/\.(xlsx|docx)$/.test(n)) {
      return loadScript(jszipUrl).then(function () { return window.JSZip.loadAsync(file); }).then(function (zip) {
        return /\.xlsx$/.test(n) ? readXlsx(zip) : readDocx(zip);
      });
    }
    return Promise.reject(new Error('type'));
  }
  function clean(list) {
    return list.map(function (s) { return String(s || '').replace(/\s+/g, ' ').trim(); }).filter(function (s) { return s && !HEAD.test(s); });
  }

  function init(el) {
    if (el.dataset.spnmReady) return;
    el.dataset.spnmReady = '1';
    var data = {};
    try { data = JSON.parse(el.querySelector('[data-spnm-data]').textContent); } catch (e) {}
    var en = !!data.en, t = en ? T.en : T.de, L = en ? 3 : 2;
    var $ = function (s) { return el.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(el.querySelectorAll(s)); };
    var VS = data.variants || [];
    // Variante je Position: Schulterblatt = „Rücken“, sonst die erste (Standard) – wie bei „Stick auf eigene Ware“
    function variant(k) {
      if (!VS.length) return null;
      if ((k || st.pos) === 'ru') {
        for (var i = 0; i < VS.length; i++) if (/r(ü|ue)cken|back/i.test(VS[i].t)) return VS[i];
        return VS[VS.length - 1];
      }
      return VS[0];
    }
    var money = function (c) {
      var n = (c / 100).toLocaleString(en ? 'en-GB' : 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return en ? '€' + n : n + '\u00a0€';
    };

    var st = { names: [], idx: 0, font: 'Dancing Script', cat: 'all', thread: 'weiss', fabric: 0, pos: 'bl', width: '8', wSet: false, tex: '', files: [], busy: false };
    var namesEl = $('[data-names]'), fileEl = $('[data-file]'), msgEl = $('[data-names-msg]'), noteEl = $('[data-note]');
    var statusEl = $('[data-status]'), addBtn = $('[data-add]'), prev = $('[data-preview]');

    /* --- Schriften --- */
    var catsBox = $('[data-cats]'), fontsBox = $('[data-fonts]');
    ['all', 'script', 'serif', 'sans', 'sport'].forEach(function (c) {
      var n = c === 'all' ? FONTS.length : FONTS.filter(function (f) { return f[1] === c; }).length;
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-pressed', c === st.cat ? 'true' : 'false'); b.dataset.cat = c;
      b.innerHTML = esc(t.cats[c]) + ' <span class="mut tn">' + n + '</span>';
      b.addEventListener('click', function () { st.cat = c; $$('[data-cat]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); renderFonts(); });
      catsBox.appendChild(b);
    });
    function sampleText() { return st.names[st.idx] || st.names[0] || t.sample; }
    function renderFonts() {
      fontsBox.innerHTML = '';
      FONTS.forEach(function (f) {
        if (st.cat !== 'all' && f[1] !== st.cat) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'spnm-font'; b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', f[0] === st.font ? 'true' : 'false');
        b.innerHTML = '<span class="spnm-font__s" style="font-family:' + esc(fam(f[0])) + '">' + esc(sampleText()) + '</span><span class="l mut">' + esc(f[0]) + '</span>';
        b.addEventListener('click', function () { st.font = f[0]; renderFonts(); update(); });
        fontsBox.appendChild(b);
      });
    }

    /* --- Garn, Stoff, Position, Textilien --- */
    var thBox = $('[data-threads]');
    THREADS.forEach(function (th) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'spnm-sw'; b.setAttribute('role', 'radio'); b.dataset.th = th[0];
      b.style.setProperty('--c', th[1]); b.setAttribute('aria-label', th[L]); b.title = th[L];
      b.addEventListener('click', function () { st.thread = th[0]; update(); });
      thBox.appendChild(b);
    });
    var fabBox = $('[data-fabrics]');
    FABRICS.forEach(function (fb, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'spnm-sw spnm-sw--s'; b.setAttribute('role', 'radio'); b.dataset.fab = i;
      b.style.setProperty('--c', fb[0]); b.setAttribute('aria-label', fb[L - 1]); b.title = fb[L - 1];
      b.addEventListener('click', function () { st.fabric = i; update(); });
      fabBox.appendChild(b);
    });
    var posBox = $('.spnm-pos'); // nicht [data-pos]: das tragen auch die Stickfelder der Zeichnung
    POS.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ptile spnm-ptile'; b.dataset.p = p[0];
      b.innerHTML = '<span class="ptile__row"><span class="ptile__n s">' + (i + 1) + '</span><span class="ptile__name"><span class="s">' + esc(p[L]) + '</span><span class="b mut tn">max. ' + p[4] + ' cm' + (variant(p[0]) ? ' · ' + money(variant(p[0]).price) : '') + '</span></span></span>';
      b.addEventListener('click', function () { setPos(p[0]); });
      posBox.appendChild(b);
    });
    $$('.flat__g').forEach(function (g) {
      g.addEventListener('click', function () { if (POS.some(function (p) { return p[0] === g.dataset.pos; })) setPos(g.dataset.pos); });
    });
    function posDef(k) { for (var i = 0; i < POS.length; i++) if (POS[i][0] === k) return POS[i]; return POS[0]; }
    function setPos(k) {
      st.pos = k;
      if (!st.wSet) { st.width = String(posDef(k)[5]); widthEl.value = st.width; }
      update();
    }
    var widthEl = $('[data-width]');
    widthEl.value = st.width;
    widthEl.addEventListener('input', function () { st.width = widthEl.value.replace(/[^0-9.,]/g, ''); st.wSet = true; if (widthEl.value !== st.width) widthEl.value = st.width; update(); });

    var texBox = $('.spnm-tex');
    [['shop', t.texShop], ['own', t.texOwn]].forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ptile spnm-texopt'; b.setAttribute('role', 'radio'); b.dataset.tex = o[0];
      b.innerHTML = '<span class="s">' + esc(o[1][0]) + '</span><span class="b mut">' + esc(o[1][1]) + '</span>';
      b.addEventListener('click', function () { st.tex = o[0]; update(); });
      texBox.appendChild(b);
    });

    /* --- Namen --- */
    function readNames() { st.names = clean(namesEl.value.split('\n')); if (st.idx >= st.names.length) st.idx = 0; }
    namesEl.addEventListener('input', function () { readNames(); renderFonts(); update(); });
    $('[data-prev]').addEventListener('click', function () { if (st.names.length) { st.idx = (st.idx - 1 + st.names.length) % st.names.length; renderFonts(); update(); } });
    $('[data-next]').addEventListener('click', function () { if (st.names.length) { st.idx = (st.idx + 1) % st.names.length; renderFonts(); update(); } });

    var upl = $('[data-upl]');
    function takeFile(f) {
      if (!f) return;
      msgEl.classList.remove('is-err');
      if (f.size > 10 * 1024 * 1024) { msgEl.textContent = t.tooBig; msgEl.classList.add('is-err'); return; }
      if (/\.(xls|doc)$/i.test(f.name)) { msgEl.textContent = t.badType; msgEl.classList.add('is-err'); return; }
      readFile(f, data.jszip).then(function (list) {
        list = clean(list);
        if (!list.length) { msgEl.textContent = t.readNone; msgEl.classList.add('is-err'); return; }
        var cur = namesEl.value.replace(/\s+$/, '');
        namesEl.value = (cur ? cur + '\n' : '') + list.join('\n');
        st.files = st.files.filter(function (x) { return x.name !== f.name; }).concat([f]).slice(-3);
        $('[data-upl-title]').textContent = t.upFile(st.files.map(function (x) { return x.name; }).join(', '));
        upl.classList.add('has-file');
        msgEl.textContent = t.read(list.length, f.name);
        readNames(); renderFonts(); update();
      }).catch(function (e) {
        msgEl.textContent = e && e.message === 'type' ? t.badType : t.readErr; msgEl.classList.add('is-err');
      });
    }
    fileEl.addEventListener('change', function () { takeFile(fileEl.files && fileEl.files[0]); fileEl.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { upl.addEventListener(ev, function (e) { e.preventDefault(); upl.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { upl.addEventListener(ev, function (e) { e.preventDefault(); upl.classList.remove('is-drag'); }); });
    upl.addEventListener('drop', function (e) { takeFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });

    /* --- Vorschau: Schriftgröße an die Stofffläche anpassen --- */
    var cloth = $('[data-cloth]');
    function fit() {
      var max = cloth.clientWidth * 0.84, size = Math.min(88, Math.max(28, cloth.clientWidth / 7));
      prev.style.fontSize = size + 'px';
      var guard = 0;
      while (prev.scrollWidth > max && size > 18 && guard++ < 40) { size -= 2; prev.style.fontSize = size + 'px'; }
    }
    if (window.ResizeObserver) new ResizeObserver(fit).observe(cloth);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'LINK') { renderFonts(); fit(); } }, true);

    function thread() { for (var i = 0; i < THREADS.length; i++) if (THREADS[i][0] === st.thread) return THREADS[i]; return THREADS[0]; }
    function errors() {
      var e = [];
      var long = st.names.filter(function (n) { return n.length > MAXLEN; }).length;
      if (long) e.push(t.tooLong(long));
      var w = parseFloat(String(st.width).replace(',', '.')), m = posDef(st.pos)[4];
      if (!(w > 0) || w > m) e.push(t.widthErr(m));
      return e;
    }

    function update() {
      var th = thread(), fab = FABRICS[st.fabric], pd = posDef(st.pos), n = st.names.length;
      // Vorschau
      cloth.style.setProperty('--fab', fab[0]);
      cloth.classList.toggle('is-light', fab[0] === '#FFFFFF' || fab[0] === '#B9BDBF');
      prev.style.setProperty('--thread', th[1]);
      prev.style.fontFamily = fam(st.font);
      prev.textContent = sampleText();
      $('[data-preview-meta]').textContent = [st.font, th[L], pd[L], (st.width || '–') + ' cm'].join(' · ');
      $('[data-pager]').textContent = (n ? st.idx + 1 : 1) + ' / ' + Math.max(1, n);
      $$('[data-prev],[data-next]').forEach(function (b) { b.disabled = n < 2; });
      fit();
      // Auswahl-Zustände
      $$('[data-th]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.th === st.thread ? 'true' : 'false'); });
      $$('[data-fab]').forEach(function (b) { b.setAttribute('aria-checked', +b.dataset.fab === st.fabric ? 'true' : 'false'); });
      $$('[data-p]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.p === st.pos ? 'true' : 'false'); });
      $$('.spnm-texopt').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.tex === st.tex ? 'true' : 'false'); });
      $$('.flat__g').forEach(function (g) { g.classList.toggle('is-on', g.dataset.pos === st.pos); g.classList.toggle('is-off', !POS.some(function (p) { return p[0] === g.dataset.pos; })); });
      $$('[data-flat]').forEach(function (f) { f.classList.toggle('is-on', f.dataset.flat === pd[1]); });
      $('[data-thread-name]').textContent = th[L];
      $('[data-font-name]').textContent = st.font;
      $('[data-width-hint]').textContent = t.max(pd[4]);
      $('[data-count]').textContent = n + (n === 1 ? t.names1 : t.namesN);
      // Schritte erledigt
      var done = { names: n > 0, font: true, thread: true, pos: errors().every(function (x) { return x.indexOf('cm') < 0; }), tex: !!st.tex };
      $$('[data-step]').forEach(function (c) { c.classList.toggle('is-done', !!done[c.dataset.step]); });
      // Summe
      var vr = variant(), price = vr ? vr.price : 0;
      var total = n * price;
      $('[data-sum-count]').textContent = n + (n === 1 ? t.names1 : t.namesN);
      var rows = [
        [t.rows.names, n + ' × ' + money(price)],
        [t.rows.font, st.font], [t.rows.thread, th[L]], [t.rows.pos, pd[L] + ', ' + (st.width || '–') + ' cm'],
        [t.rows.tex, st.tex ? (st.tex === 'shop' ? t.texShopShort : t.texOwnShort) : '–']
      ];
      $('[data-sum-rows]').innerHTML = rows.map(function (r) { return '<div><dt class="spnm-night">' + esc(r[0]) + '</dt><dd class="tn">' + esc(r[1]) + '</dd></div>'; }).join('');
      $('[data-sum-total]').textContent = money(total);
      $('[data-mbar-total]').textContent = money(total);
      $('[data-mbar-sub]').textContent = n + (n === 1 ? t.names1 : t.namesN);
      var errs = errors();
      var ready = n > 0 && !!st.tex && !errs.length && !!(vr && vr.av);
      addBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      if (!statusEl.dataset.keep) {
        statusEl.classList.toggle('is-err', !!errs.length);
        statusEl.textContent = errs.join(' ');
      }
    }

    /* --- Warenkorb --- */
    function nameList() {
      var th = thread(), pd = posDef(st.pos);
      var head = [t.listHead, '', (en ? 'Font: ' : 'Schrift: ') + st.font, (en ? 'Thread: ' : 'Garnfarbe: ') + th[L],
        (en ? 'Position: ' : 'Position: ') + pd[L] + ', ' + st.width + ' cm', (en ? 'Textiles: ' : 'Textilien: ') + (st.tex === 'shop' ? t.texShopShort : t.texOwnShort),
        (en ? 'Names: ' : 'Anzahl Namen: ') + st.names.length, ''];
      return head.concat(st.names.map(function (n, i) { return (i + 1) + '. ' + n; })).join('\r\n') + '\r\n';
    }
    addBtn.addEventListener('click', function () {
      if (st.busy) return;
      delete statusEl.dataset.keep;
      statusEl.classList.add('is-err');
      var vr = variant();
      if (!vr || !vr.av) { statusEl.textContent = t.soldOut; return; }
      if (!st.names.length) { statusEl.textContent = t.needNames; namesEl.focus(); return; }
      var errs = errors();
      if (errs.length) { statusEl.textContent = errs.join(' '); return; }
      if (!st.tex) { statusEl.textContent = t.needTex; $('[data-step="tex"]').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      statusEl.classList.remove('is-err');
      var th = thread(), pd = posDef(st.pos);
      var joined = '', cut = 0;
      st.names.forEach(function (n, i) { if (cut) { cut++; return; } var add = (i ? ', ' : '') + n; if ((joined + add).length > 480) { cut = 1; } else joined += add; });
      if (cut) joined += t.more(cut);
      var props = {
        'Schrift': st.font,
        'Garnfarbe': th[2],
        'Position': pd[2],
        'Breite': String(st.width).replace('.', ',') + ' cm',
        'Textilien': st.tex === 'shop' ? 'aus dem Shop' : 'eigene Textilien',
        'Namen': joined
      };
      var note = (noteEl.value || '').trim().slice(0, 500);
      if (note) props['Hinweis'] = note;
      var fd = new FormData();
      fd.append('items[0][id]', vr.id);
      fd.append('items[0][quantity]', st.names.length);
      Object.keys(props).forEach(function (k) { fd.append('items[0][properties][' + k + ']', props[k]); });
      var stamp = new Date().toISOString().slice(0, 10);
      fd.append('items[0][properties][Namensliste]', new File([nameList()], 'namensliste-' + stamp + '.txt', { type: 'text/plain' }));
      st.files.forEach(function (f, i) { fd.append('items[0][properties][Originaldatei' + (i ? ' ' + (i + 1) : '') + ']', f, f.name); });
      st.busy = true; addBtn.classList.add('is-loading');
      statusEl.textContent = t.adding;
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || t.fail);
          statusEl.dataset.keep = '1';
          statusEl.innerHTML = esc(t.added) + ' <a href="' + esc(data.cartUrl || root() + 'cart') + '">' + esc(t.toCart) + ' →</a>' +
            (st.tex === 'shop' ? ' · <a href="' + esc(data.shopUrl) + '">' + esc(t.toShop) + ' →</a>' : '');
          try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        })
        .catch(function (e) { statusEl.classList.add('is-err'); statusEl.textContent = (e && e.message) || t.fail; })
        .then(function () { st.busy = false; addBtn.classList.remove('is-loading'); });
    });

    /* --- Mobile Leiste: sichtbar, solange der Designer im Bild und die Summe nicht sichtbar ist --- */
    var mbar = $('[data-mbar]'), sum = $('[data-sum]');
    if (window.IntersectionObserver && mbar) {
      var inSec = false, inSum = false;
      var sync = function () { mbar.hidden = !(inSec && !inSum); };
      new IntersectionObserver(function (e) { inSec = e[0].isIntersecting; sync(); }, { rootMargin: '-30% 0px -30% 0px' }).observe(el.querySelector('.spnm__grid'));
      new IntersectionObserver(function (e) { inSum = e[0].isIntersecting; sync(); }).observe(sum);
    }

    renderFonts();
    update();
  }

  function start() { document.querySelectorAll('[data-spnm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
